module.exports = __webpack_public_path__ + "img/38.3c67195d.jpg";